import { takeEvery, put, call, fork, ForkEffect, select } from 'redux-saga/effects'
import {
  REMOVE_PRACTICE_SUBMIT,
  removePracticeSuccess,
  removePracticeFail,
} from '../../actions/RemovePractice/removePracticeActions'
import { ResponseStatus, post } from '../../fetch'
import { validateString, FieldValueType } from '../../components/forms/validations'
import text from '../../_constants/text'

const REMOVE_PRACTICE_PATH = '/practice/remove'

function* removePracticeApi({ payload }) {
  try {
    // Validate providerNumber and practiceName
    const providerNumberValid = validateString(FieldValueType.PROVIDER, true, payload.providerNumber)
    const practiceNameValid = validateString(FieldValueType.CLINIC, true, payload.practiceName)
    if (!providerNumberValid || !practiceNameValid) {
      yield put(removePracticeFail(text.REMOVE_PRACTICE_INVALID_DETAILS))
      return
    }
    // Get JWT token and practitioner email from state
    const jwt = yield select((state) => state.login.token)
    const practitionerEmail = yield select((state) => state.account.email)
    // Prepare RemovePracticeApiRequest payload
    const apiPayload = {
      providerNumber: payload.providerNumber,
      name: payload.practiceName,
      practitionerEmail,
    }
    // API call with JWT token in headers
    const response = yield call(
      post,
      `${process.env.REACT_APP_API_URL}${REMOVE_PRACTICE_PATH}`,
      { Authorization: `${jwt.type} ${jwt.token}` },
      apiPayload,
    )
    if (response.status === ResponseStatus.SUCCESS) {
      yield put(removePracticeSuccess(payload.providerNumber, payload.practiceName))
    } else {
      yield put(removePracticeFail(text.REMOVE_PRACTICE_UNKNOWN_ERROR))
    }
  } catch (error) {
    console.error(error)
    yield put(removePracticeFail(text.REMOVE_PRACTICE_UNKNOWN_ERROR))
  }
}

function* watchRemovePractice(): Generator<ForkEffect<never>, void, unknown> {
  yield takeEvery(REMOVE_PRACTICE_SUBMIT as unknown as never, removePracticeApi)
}

const removePracticeSaga = [fork(watchRemovePractice)]

export default removePracticeSaga
